import { useLang } from "@/context/LangContext";
import { LANGUAGES } from "@/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger
        data-testid="language-switcher"
        className="w-auto gap-2 rounded-full border-border/60 bg-card/70 px-3 h-10"
      >
        <Globe className="h-4 w-4 text-primary" />
        <span className="text-sm font-medium">{current.flag} {current.code.toUpperCase()}</span>
      </SelectTrigger>
      <SelectContent className="max-h-80">
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
            <span className="me-2">{l.flag}</span>{l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
